function calcularPrimeiroDigito(cpf: string): number {
    const numerosCpf: number[] = cpf
      .replace(/\D/g, '')
      .slice(0, 9)
      .split('')
      .map(Number);
  
    const soma: number = numerosCpf.reduce((acc, value, i) => acc + value * (10 - i), 0);
    const resultado: number = (soma * 10) % 11;
  
    return resultado > 9 ? 0 : resultado;
  }
  
  function calcularSegundoDigito(cpf: string): number {
    const numerosCpf: number[] = cpf
      .replace(/\D/g, '')
      .slice(0, 10)
      .split('')
      .map(Number);
  
    const soma: number = numerosCpf.reduce((acc, value, i) => acc + value * (11 - i), 0);
    const resultado: number = (soma * 10) % 11;
  
    return resultado > 9 ? 0 : resultado;
  }
  
  export function validateCpf(cpf: string): boolean {
    const cpfSemMascara: string = cpf.replace(/\D/g, '');
  
    if (/^(\d)\1{10}$/.test(cpfSemMascara)) {
      return false;
    }
  
    if (cpfSemMascara.length !== 11) {
      return false;
    }
  
    const primeiroDigito: number = calcularPrimeiroDigito(cpfSemMascara);
    const segundoDigito: number = calcularSegundoDigito(cpfSemMascara);
  
    return (
      parseInt(cpfSemMascara.charAt(9)) === primeiroDigito &&
      parseInt(cpfSemMascara.charAt(10)) === segundoDigito
    );
  }